
import React, { Component } from 'react';
import '../Text/text.css'
import {serverUrl} from '../../../utils/restUtils'
import { Editor } from '@tinymce/tinymce-react';
import { change } from 'redux-form';
class Text  extends Component{

    
    render() {

	const { input, label, type, icon, unit, meta: { dispatch, form, touched, error } } = this.props
	
	const setValue = (text) => {	
	    dispatch(change(form, input.name, text))
	}

	return (
	    
	    <div className={['electroInput', ((error) ? 'error' : ''), ((input.value) ? 'touched' : '')].join(" ")} >
		<div>
		    
		    <label>
			{label}
			<span className="errorLabel"> - {error}</span>
		    </label>
		    
		    <textarea {...input} autoComplete="off" placeholder={label} className="textarea"/>
		</div>
	    </div>
	)
    }
}

export default Text



// WEBPACK FOOTER //
// ./src/components/Inputs/Textarea2/Textarea.jsx